/**
 * The header wordmark, loaded from a static SVG in public/.
 *
 * Which wordmark depends on the host: Husly on Husly's own hub, the operator's
 * on the client portal (see lib/brand.ts). `variant="icon"` is the square mark
 * and stays Husly's - it is only used where the app identifies ITSELF (the
 * favicon slot and the mobile header), never as the client-facing brand.
 */
import { brandLogo } from "../lib/brand";

export interface LogoProps {
  variant?: "full" | "icon";
  className?: string;
}

export function Logo({ variant = "full", className }: LogoProps) {
  if (variant === "icon") {
    return (
      <>
        <img
          src="/favicon.svg?v=brown2"
          alt="Husly"
          className={`${className || ""} dark:hidden`}
          role="img"
          draggable={false}
        />
        <img
          src="/favicon-dark.svg?v=brown2"
          alt="Husly"
          className={`${className || ""} hidden dark:block`}
          role="img"
          draggable={false}
        />
      </>
    );
  }
  const brand = brandLogo();
  return (
    <>
      <img
        src={brand.light}
        alt={brand.alt}
        className={`${className || ""} dark:hidden`}
        role="img"
        draggable={false}
      />
      <img
        src={brand.dark}
        alt={brand.alt}
        className={`${className || ""} hidden dark:block`}
        role="img"
        draggable={false}
      />
    </>
  );
}
